// Copyright (C) 2019 Berkadia Commercial Mortgage, LLC - All Rights Reserved

import React from 'react'
import PropTypes from 'prop-types'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import Button from '@material-ui/core/Button'
import './PopUpDialog.scss'

function PopUpDialog(props) {

  const { popUpDialogOpen, popUpDialogmessage, canceleDialog, discardDialog, saveDialog, title, cancelMessage, saveMessage, confirmMessage } = props

  return (
    <Dialog
      open={popUpDialogOpen}
      aria-labelledby="discard-dialog-title"
      aria-describedby="discard-dialog-description"
      data-testid="discard-comps-dialog"
    >
      <DialogTitle
        id="discard-comps-dialog-title"
      >
        <span className="dicard-title">{title}</span>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="discard-dialog-description">
          <span className="dicard-description">{popUpDialogmessage}</span>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        {saveMessage && (
          <Button
            data-testid="button-discard-comps-save"
            onClick={() => saveDialog()}
            size="large"
            id="button-discard-comps-save"
          >
            {saveMessage}
          </Button>
        )}
        <Button
          data-testid="button-discard-comps-cancel"
          onClick={() => canceleDialog()}
          size="large"
          id="button-discard-comps-cancel"
        >
          {cancelMessage}
        </Button>
        <Button
          data-testid="button-canceleDialog-comps-discard"
          onClick={() => discardDialog()}
          size="large"
          id="button-discard-comps-discard"
        >
          {confirmMessage}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

PopUpDialog.propTypes = {
  popUpDialogOpen: PropTypes.bool,
  popUpDialogmessage: PropTypes.string,
  saveDialog: PropTypes.func,
  canceleDialog: PropTypes.func,
  discardDialog: PropTypes.func,
  title: PropTypes.string,
  cancelMessage: PropTypes.string,
  saveMessage: PropTypes.string,
  confirmMessage: PropTypes.string
}

export default PopUpDialog
